const FLAG_KEY = 'webview_to_native_flag'

export const setWebviewToNativeFlag = $storage => {
  if ($storage) {
    const flagStorage = $storage.create(FLAG_KEY, { strategy: 'SESSION' }) 
    flagStorage.setItem(true)
  }
}

export const hasWebviewToNativeFlag = $storage => {
  if ($storage) {
    const flagStorage = $storage.create(FLAG_KEY, { strategy: 'SESSION' })
    const flag = flagStorage.getItem()
    return flag === true
  }
  return false
}

export const clearWebviewToNativeFlag = $storage => {
  if ($storage) {
    const flagStorage = $storage.create(FLAG_KEY, { strategy: 'SESSION' })
    const flag = flagStorage.getItem()
    const hasFlag = flag === true
    if (hasFlag) {
      flagStorage.clearItem()
    }
  }
}